export const HolidayMessage = {
    init: () => {
        const messageBanner = document.getElementById('holiday-message');
        // const navBar = document.querySelector('.navbar');
        const searchPanel = document.querySelector('.search-box--desktop');
        // const banner = document.querySelector('.section-home-banner .banner');
        // const dismissButton = document.getElementById('dismiss-button');

        // // if localStorage is supported and holidayMessageDismissed key is not present or not equal to true in localStorage then show messageBanner
        // if (
        //     typeof Storage !== 'undefined' &&
        //     localStorage.getItem('holidayMessageDismissed') !== 'true'
        // ) {
        //     messageBanner.classList.remove('is-hidden');
        //     messageBanner.setAttribute('aria-hidden', 'false');
        //     messageBanner.classList.remove('hidden');
        // }
        // // add event listener to dismissButton
        // dismissButton.addEventListener('click', () => {
        //     // if localStorage is supported add a key holidayMessageDismissed to localStorage on click of dismiss button
        //     if (typeof Storage !== 'undefined') {
        //         localStorage.setItem('holidayMessageDismissed', 'true');
        //     }
        //     // add class is-hidden to messageBanner
        //     messageBanner.classList.add('is-hidden');
        //     // remove messageBanner from DOM
        //     // e.stopPropagation();
        //     messageBanner.setAttribute('aria-hidden', 'true');
        //     messageBanner.classList.add('hidden');
        //     messageBanner.remove();
        //     navBar.style.top = 0;
        // });

        /*

        handle holiday message banner top padding

        */

        const isDesktop = window.matchMedia('(min-width: 1024px)').matches;

        if (searchPanel && isDesktop) {
            messageBanner.style.paddingTop =
                searchPanel.clientHeight / 2 + 32 + 'px';
        }

        /*

        handle navigation height and sticky nav

        */
        // if (messageBanner && navBar) {
        //     const messageBannerHeight = `${messageBanner.clientHeight.toString()}px`;
        //     navBar.style.top = messageBannerHeight;

        //     document.addEventListener('scroll', navPositionoffset);

        //     function navPositionoffset() {
        //         if (window.scrollY > 0) {
        //             navBar.style.top = 0;
        //             if (navBar.classList.contains('hide-navbar')) {
        //                 navBar.style.transform = `translateY(-${navBar.clientHeight.toString()}px)`;
        //             } else {
        //                 navBar.style.transform = 'translateY(0)';
        //             }
        //         } else {
        //             if (document.getElementById('holiday-message')) {
        //                 navBar.style.top = messageBannerHeight;
        //             }
        //         }
        //     }
        // }

        /*

        handle banner height and site banner position

        */
        // if (banner && searchPanel) {
        //     if (messageBanner) {
        //         banner.style.maxHeight = `calc(100vh - ${(
        //             searchPanel.clientHeight / 2 +
        //             messageBanner.clientHeight
        //         ).toString()}px)`;
        //     } else {
        //         banner.style.maxHeight = `calc(100vh - ${(
        //             searchPanel.clientHeight / 2
        //         ).toString()}px)`;
        //     }
        // }
    },
};
